// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-1839c180]{border-collapse:collapse}table[data-v-1839c180],td[data-v-1839c180],th[data-v-1839c180]{border:.5px solid #000}thead[data-v-1839c180]{display:table-row-group}tr td[data-v-1839c180]{page-break-inside:avoid}.no-border[data-v-1839c180]{border:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
